<template>
    <v-container>
        <v-row class="mt-3" align="center">
            <v-col cols="8">
                <div class="headline-light secondary-color">
                    Perfil {{ currentEntityLabel }}
                </div>
                <div class="display-heavy primary-color">
                    Detalle de paciente
                </div>
            </v-col>
            <v-col cols="4">
                <graphics-card
                    img="bars-green"
                    color="#F4F7FE"
                    title="Total Pacientes"
                    :number="totalPatients.number"
                    :percent="totalPatients.percent"
                    min-height="97px"
                />
            </v-col>
        </v-row>
        <loading-spinner v-if="loadingPatient"/>
        <v-row v-else>
            <v-col cols="12" md="6">
                <v-sheet class="white-card pa-5">
                    <client-profile-info :user="patient" readonly/>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="6">
                <client-bought-info :user="patient" readonly/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import GraphicsCard from "@/components/cards/GraphicsCard";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import httpService from "@/services/httpService";
import ClientProfileInfo from "@/components/client/ClientProfileInfo";
import ClientBoughtInfo from "@/components/client/ClientBoughtInfo";

export default {
    name: "PatientsDetails",
    components: {
        ClientBoughtInfo,
        LoadingSpinner,
        ClientProfileInfo,
        GraphicsCard
    },
    data() {
        return {
            loadingPatient: false,
            patient: null,
        }
    },
    computed: {
        patientId(vm = this) {
            return vm.$route.params.patientId || null
        },
        totalPatients(vm = this) {
            return {
                number: vm.statsDashboard?.total_patients || 0,
                percent: vm.statsDashboard?.new_patients_percentage || 0
            }
        },
    },
    async mounted() {
        const vm = this
        await vm.loadPatient()
    },
    methods: {
        async loadPatient() {
            const vm = this
            vm.loadingPatient = true
            let response = await httpService.get(`users/${vm.patientId}`)
            vm.patient = response.data.user
            vm.loadingPatient = false
        },
    }
}
</script>

<style scoped>

</style>